var _path, _rect;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1236 6.6665C14.303 8.17626 15.1648 9.07626 16.6627 9.17204V10.8701C15.7946 10.953 15.0341 10.6754 14.1498 10.1519V13.3277C14.1498 17.3622 9.65245 18.623 7.84447 15.7311C6.68257 13.8705 7.39406 10.6052 11.121 10.4743V12.265C10.8371 12.3096 10.5336 12.38 10.2561 12.4725C9.42707 12.747 8.95722 13.2608 9.08768 14.1674C9.33904 15.9038 12.596 16.4176 12.3252 13.0246V6.66979H14.1234V6.6665H14.1236Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "white",
    strokeWidth: 2
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.8a0c3c5b758341bf54f8eba45a267e9e.svg";
export { ForwardRef as ReactComponent };